define('models/pages/organization/markers',['require','underscore','models/base/model','models/base/collection'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Model = require('models/base/model'),
        Collection = require('models/base/collection');

    var MarkerItem = Model.extend({
        urlPath: function() {
            var id = this.get(this.idAttribute) || '';
            return '/api/marker' + (id ? '/' : '') + id;
        },
        idAttribute: 'ID',
        defaults: {
            Code: '',
            Name: '',
            Phone: '',
            Address: '',
            Comment: ''
        },
        validate: function(attrs) {
            var errors = [];
            var eRequired = 'Поле должно быть заполнено';
            if (!attrs.Code) {
                errors.push(['Code', eRequired]);
            } else {
                if (attrs.Code.length > 2) {
                    errors.push(['Code', 'Длинна поля 2 символа']);
                }
            }
            return errors.length ? _.object(errors) : null;
        }
    });

    var OrganizationMarkersCollection = Collection.extend({
        model: MarkerItem
    });

    var OrganizationMarkers = Model.extend({
        urlPath: '/api/marker',
        defaults: {
            selected: null
        },
        constructor: function(data) {
            var _this = this;

            var markers = new OrganizationMarkersCollection(data ? data.markers : [], { parse: true });
            markers.on('change:selected', function(model, value) {
                if (value) {
                    markers.each(function(item) {
                        if (item !== model && item.get('selected')) {
                            item.set('selected', false);
                        }
                    });
                    _this.set('selected', model);
                }
            });
            markers.on('delete', function() {
                _this.trigger('delete');
            });

            this.markers = markers;

            Model.apply(this, arguments);
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.markers.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            var selected = this.get('selected');
            this.markers.reset(data, { silent: true });
            if (selected) {
                var found = this.markers.findWhere({ ID: selected.get('ID') });
                if (found) {
                    found.set('selected', true);
                }
            }
            return {};
        }
    });

    return OrganizationMarkers;
});
